import { Toolbar } from "@material-ui/core";

export type { ToolbarProps } from "@material-ui/core";

export default Toolbar;
